import React from 'react'
import { observer } from 'mobx-react'
import InputWrapper from '../../../../../lib/components/Forms/InputWrapper'

const BasicForm = ({ caseCheckoutStore }) => {
  const handleChangeFirstName = (val) => caseCheckoutStore.changeFirstName(val)
  const handleChangeLastName = (val) => caseCheckoutStore.changeLastName(val)
  const handleChangePhone = (val) => caseCheckoutStore.changePhone(val)
  const handleChangeEmail = (val) => caseCheckoutStore.changeEmail(val.trim())

  const { firstName, lastName, phone, email } = caseCheckoutStore

  return (
    <div className="grid gap-4 grid-cols-2">
      <InputWrapper label="First Name*" inputStore={firstName} onChange={handleChangeFirstName} maxlength="35"/>
      <InputWrapper label="Last Name*" inputStore={lastName} onChange={handleChangeLastName} maxlength="35"/>
      <div className="col-span-2 sm:col-auto">
        <InputWrapper label="Phone number*" inputStore={phone} onChange={handleChangePhone} maxlength="20"/>
      </div>
      <div className="col-span-2 sm:col-auto">
        <InputWrapper label="Email*" inputStore={email} onChange={handleChangeEmail} email/>
      </div>
    </div>
  )
}

export default observer(BasicForm)
